import { Injectable } from '@angular/core';
import { TableCollectionActionBuilder } from '../builders/table-collection-action.builder';

@Injectable({
  providedIn: 'root',
})
export class TableCollectionActionBuilderFactory<Item, Filter, Action> {
  public create(): TableCollectionActionBuilder<Item, Filter, Action> {
    return new TableCollectionActionBuilder<Item, Filter, Action>();
  }
}
